// options are used in Demand Form 

const impressionsOptions = [
   { name: "All", value: "ALL" },
   { name: "Audio", value: "AUDIO" },
   { name: "Video", value: "VIDEO" },
   { name: "Native", value: "NATIVE" },
   { name: "Banner", value: "BANNER" }
];

const auctionTypeOptions = [
   { name: "First price", value: "First_Price" },
   { name: "Second price", value: "Second_Price" }
];

const demandTypeOptions = [
   { name: "Xandr", value: "xandr" },
   { name: "Unruly", value: "unruly" },
   { name: "Rubicon", value: "rubicon" },
   { name: "Loopme", value: "loopme" },
   { name: "Triplelift", value: "triplelift" },
   { name: "Pubmatic", value: "pubmatic" },
   { name: "Bidswitch", value: "bidswitch" },
   { name: "Epsilon", value: "epsilon" },
   { name: "Smartadserver", value: "smartadserver" },
   { name: "Inmobi", value: "INMOBI" },
   { name: "Pulsepoint", value: "PULSEPOINT" },
   { name: "Bidmachine", value: "BIDMACHINE" },
   { name: "Azerion", value: "AZERION" },
   { name: "Onetag", value: "ONETAG" },
   { name: "Medianet", value: "MEDIANET" },
   { name: "Sonobi", value: "SONOBI" },
   { name: "Brave", value: "BRAVE" },
   { name: "Sovrn", value: "SOVRN" },
   { name: "Admixer", value: "ADMIXER" },
   { name: "Ortb", value: "ortb" },
   { name: "Ortbws", value: "ortbws" },
   { name: "Colossus", value: "Colossus" },
   { name: "Vistar", value: "VISTAR" },
   { name: "Placeexchange", value: "PLACEEXCHANGE" },
   { name: "Freewheel", value: "FREEWHEEL" },

];

const endpointDataCenterLocationOptions = [
   { name: "US East (Ohio)", value: "US_EAST_OHIO" },
   { name: "US East (N. Virginia)", value: "US_EAST_N_VIRGINIA" },
   { name: "US West (N. California)", value: "US_WEST_N_CALIFORNIA" },
   { name: "US West (Oregon)", value: "US_WEST_OREGON" },
   { name: "Africa (Cape Town)", value: "AFRICA_CAPETOWN" },
   { name: "Asia Pacific (Hong Kong)", value: "ASIA_PACIFIC_HONGKONG" },
   { name: "Asia Pacific (Hyderabad)", value: "ASIA_PACIFIC_HYDERABAD" },
   // { name: "Asia Pacific (Jakarta)", value: "ASIA_PACIFIC_JAKARTA" },   // not add in backend
   // { name: "Asia Pacific (Melbourne)", value: "ASIA_PACIFIC_MELBOURNE" }, // not add in backend
   { name: "Asia Pacific (Mumbai)", value: "ASIA_PACIFIC_MUMBAI" },
   { name: "Asia Pacific (Osaka)", value: "ASIA_PACIFIC_OSAKA" },
   { name: "Asia Pacific (Seoul)", value: "ASIA_PACIFIC_SEOUL" },
   { name: "Asia Pacific (Singapore)", value: "ASIA_PACIFIC_SINGAPORE" },
   { name: "Asia Pacific (Sydney)", value: "ASIA_PACIFIC_SYDNEY" },
   { name: "Asia Pacific (Tokyo)", value: "ASIA_PACIFIC_TOKYO" },
   { name: "Canada (Central)", value: "CANADA_CENTRAL" },
   { name: "Canada West (Calgary)", value: "CANADA_WEST_CALGARY" },
   { name: "Europe (Frankfurt)", value: "EUROPE_FRANKFURT" },
   { name: "Europe (Ireland)", value: "EUROPE_IRELAND" },
   { name: "Europe (London)", value: "EUROPE_LONDON" },
   { name: "Europe (Milan)", value: "EUROPE_MILAN" },
   { name: "Europe (Paris)", value: "EUROPE_PARIS" },
   { name: "Europe (Spain)", value: "EUROPE_SPAIN" },
   { name: "Europe (Stockholm)", value: "EUROPE_STOCKHOLM" },
   { name: "Europe (Zurich)", value: "EUROPE_ZURICH" },
   { name: "Israel (Tel Aviv)", value: "ISRAEL_TEL_AVIV" },
   { name: "Middle East (Bahrain)", value: "MIDDLE_EAST_BAHRAIN" },
   { name: "Middle East (UAE)", value: "MIDDLE_EAST_UAE" },
   { name: "South America (São Paulo)", value: "SOUTH_AMERICA_SAO_PAULO" },
   { name: "AWS GovCloud (US-East)", value: "AWS_GOVCLOUD_US_EAST" },
   { name: "AWS GovCloud (US-West)", value: "AWS_GOVCLOUD_US_WEST" }
];

const budgetPacingOptions = [{
   name: "As soon as possible", value: "AS_SOON_AS_POSSIBLE"
},
{ name: "Smooth through the day", value: "SMOOTH_THROUGH_THE_DAY" }
];


export { impressionsOptions, auctionTypeOptions, demandTypeOptions, endpointDataCenterLocationOptions, budgetPacingOptions };


/// added here new options 
